import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { ContactForm } from './ContactForm';
import { CONTACT_ADDRESS, CONTACT_EMAIL, CONTACT_PHONE, MAILTO } from '../data/content';
export function Contact() {
  return <section id="contact" aria-labelledby="contact-heading" className="scroll-mt-16 bg-white py-20 sm:py-24" data-id="element-24" data-mp="316tp7d8k0v7c">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-25" data-mp="3sxq0i9eyursi">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-26" data-mp="3swy7958ud65e">
          <div data-id="element-27" data-mp="3ovw6ul36uo1u">
            <h2 id="contact-heading" className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-28" data-mp="3oxfn4bougz3m">
              Contact
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-ink-muted" data-id="element-29" data-mp="3f59xh8m2etrl">
              Reach us directly by email, or send a message and we will get back
              to you.
            </p>

            <a href={MAILTO} className="mt-8 inline-flex max-w-full items-center gap-3 rounded-xl border border-hairline bg-slate-50 px-5 py-4 transition-colors duration-150 ease-out hover:border-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-30" data-mp="bpchuk54wtlv">
              <MailIcon className="h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-31" data-mp="3b3109f4hijyz" />
              <span className="break-all text-lg font-semibold text-accent sm:text-xl" data-id="element-32" data-mp="315d18czuiqb0">
                {CONTACT_EMAIL}
              </span>
            </a>

            <dl className="mt-8 space-y-5 border-t border-hairline pt-8" data-id="element-33" data-mp="365r83rppnu7g">
              <div className="flex gap-3" data-id="element-34" data-mp="2s5gies050lnv">
                <PhoneIcon className="mt-0.5 h-5 w-5 shrink-0 text-ink-light" aria-hidden="true" data-id="element-35" data-mp="2s6rmyu1epxg1" />
                <div data-id="element-36" data-mp="qe3fg8hqcnug">
                  <dt className="text-sm font-medium text-ink" data-id="element-37" data-mp="qdjwcogcfteu">Phone</dt>
                  <dd className="mt-0.5 text-[15px] text-ink-muted" data-id="element-38" data-mp="udm0r5dgr0xt">
                    <a href="tel:+5491135832093" className="hover:text-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-39" data-mp="23bc372y1efyz">
                      {CONTACT_PHONE}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex gap-3" data-id="element-40" data-mp="1pcuizf7cbllt">
                <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-ink-light" aria-hidden="true" data-id="element-41" data-mp="1pe5lzcsyopbv" />
                <div data-id="element-42" data-mp="2i1jdgvdw4sol">
                  <dt className="text-sm font-medium text-ink" data-id="element-43" data-mp="2i1025xiqx2jj">Office</dt>
                  <dd className="mt-0.5 text-[15px] text-ink-muted" data-id="element-44" data-mp="2d8q8c6eifibz">
                    {CONTACT_ADDRESS}
                  </dd>
                </div>
              </div>
            </dl>
          </div>

          <ContactForm data-id="element-45" data-mp="35r45e3s0v0a0" />
        </div>
      </div>
    </section>;
}